import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";


export const fetchAllDestination = createAsyncThunk(
  "destination/fetchAllDestination",
  async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/alldestination`);     
        return response.data.data;  
      } catch (error) {
        throw new Error(error.response?.data?.message || error.message);  
      }
   
  }
);

export const addDestination = createAsyncThunk(
  "destination/addDestination", 
  async (formData) => {
  try {
    const response = await axios.post(`${REACT_APP_API_URL}api/dashboard/admin/destinationadd`,formData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
 
});

export const updateDestination = createAsyncThunk(
  "destination/updateDestination",
  async (formData) => {
    try {
      const response = await axios.put(`${REACT_APP_API_URL}api/dashboard/admin/destinationupdate/${formData.id}`, formData);
      console.log("Update response:", response.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }
);

export const deleteDestination = createAsyncThunk(
  "destination/deleteDestination",
  async (id) => {
    try {
      const response = await axios.delete(`${REACT_APP_API_URL}api/dashboard/admin/destinationdelete/${id}`);
      return response.data; 
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }
);

const destinationSlice = createSlice({
  name: "destination",
  initialState: {
    destinationData: [],
    status: "idle",
    error: null,
    selectedDistrict: "",
  },
  reducers: {
    setSelectedDistrict: (state, action) => {
      state.selectedDistrict = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllDestination.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllDestination.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.destinationData  = action.payload;
        state.error = null; 
      })
      .addCase(fetchAllDestination.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message; 
      })
      .addCase(addDestination.fulfilled, (state, action) => {
        state.destinationData.push(action.payload);
      })
      .addCase(updateDestination.fulfilled, (state, action) => {
        const index = state.destinationData.findIndex(dest => dest.id === action.payload.id);
        if (index !== -1) {
          state.destinationData[index] = action.payload; 
        }
      })
      .addCase(deleteDestination.fulfilled, (state, action) => {

        state.destinationData = state.destinationData.filter(dest => dest.id !== action.payload.id);
      });
      
  },
});
export const { setSelectedDistrict } = destinationSlice.actions;
export default destinationSlice.reducer;
